module.exports = __webpack_public_path__ + "media/vid_support.1bc89cfe.mp4";